<template>
<!-- 串联单详情页 -->
<div class="bg">
  <headline :params="headLines" />
  <div class="container">
    <div class="content">
      <article :class="{center: true}">
        <div class="top">
          <div class="title">
            <h4 v-if="detail">{{detail.report_title}}</h4>
          </div>
          <div class="date">
            <!-- <label v-if="detail" :class="{card: detail.uid != 0}" @click="showCard(detail.uid, $event)">
              {{detail.user_name}}
            </label> -->
            <span v-if="detail">{{detail.raw_update_time}}</span>
          </div>
          <div class="sub">
            <label>创建部门：</label>
            <span>{{detail.depart_title || '无'}}</span>
            <label>发送平台：</label>
            <span>{{detail.push_platform || '无'}}</span>
            <label>信源：</label>
            <span>{{(detail.source_info && detail.source_info.ptitle) || '无'}}</span>
            <label>频道：</label>
            <span>{{(detail.source_info && detail.source_info.stitle) || '无'}}</span>
          </div>
        </div>
        <div class="warning" v-if="detail.warning_content">
          <img src="@assets/img/common/warn.svg" alt="warn">
          <div class="info">
            <div class="about">
              <span class="name">{{detail.warning_username}}</span>
              <span>{{detail.warning_addtime}}</span>
            </div>
            <div class="detail">
              {{detail.warning_content}}
            </div>
          </div>
        </div>
        <div class="infoBox">
          <div v-if="detail.type == 0" class="details" v-html="content" id="content"></div>
          <div v-else class="details editable">{{content}}</div>
          <div class="count" v-if="detail.type == 1">
            <label>正文：</label><span>{{bodyText.length}}字 {{Math.ceil(bodyDurantion)}}秒</span>
            <label>导语：</label><span>{{headText.length}}字 {{Math.ceil(headDurantion)}}秒</span>
            <label>语速：</label><span>{{speed}}字/分钟</span>
          </div>
          <div class="column">
            <ul>
              <li><label>记者</label>
                <a href="#" @click.prevent="">{{detail.reporters}}</a>
                <span v-if="!detail.reporters" class="no">无</span>
              </li>
              <li><label>摄像</label>
                <a href="#" @click.prevent="">{{detail.cameras}}</a>
                <span v-if="!detail.cameras" class="no">无</span>
              </li>
              <li><label>所属策划</label>
                <!-- <router-link :to="`/topicDetail?d=${detail.st_id}`">{{detail.st_title}}</router-link> -->
                <a href="#" @click.prevent="goTopic()">{{detail.st_title}}</a>
                <span v-if="!detail.st_title" class="no">无</span>
              </li>
              <li><label>来源采访</label>
                <!-- <router-link :to="`/interviewDetail?r=${detail.iview_id}`">{{detail.iview_title}}</router-link> -->
                <a href="#" @click.prevent="goItv()">{{detail.iview_title}}</a>
                <span v-if="!detail.iview_title" class="no">无</span>
              </li>
              <li v-if="detail"><label>标签</label>
                <small @click="goTags(item)" v-for="(item,index) in detail.tags" :key="index">{{item.title}}</small>
                <span class="no" v-if="!detail.tags || detail.tags.length === 0">无</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="extendInfo" v-show="showExtendInfo">
          <div class="title">
            扩展信息
          </div>
          <div class="line">
            <div class="part">
              <span class="partTitle">
                发生地点
              </span>
              <span class="partContent">
                {{detail.hanppen_address}}
              </span>
            </div>
            <div class="part">
              <span class="partTitle">
                发生时间
              </span>
              <span class="partContent">
                {{detail.hanppen_time}}
              </span>
            </div>
          </div>
          <div class="line">
            <div class="part">
              <span class="partTitle">
                发布时间
              </span>
              <span class="partContent">
                {{detail.release_time}}
              </span>
            </div>
            <div class="part">
              <span class="partTitle">
                抓取时间
              </span>
              <span class="partContent">
                {{detail.grab_time}}
              </span>
            </div>
          </div>
          <div class="line">
            <div class="part">
              <span class="partTitle">
                保密等级
              </span>
              <span class="partContent">
                {{detail.secret_level}}
              </span>
            </div>
            <div class="part">
              <span class="partTitle">
                收录时间
              </span>
              <span class="partContent">
                {{detail.included_time}}
              </span>
            </div>
          </div>
          <div class="line">
            <div class="part">
              <span class="partTitle">
                简介
              </span>
              <span class="partContent">
                {{detail.info}}
              </span>
            </div>
          </div>
        </div>
        <div class="exender" @click="toggleExtendor()">
          <span>
            {{showExtendInfo?'收起扩展信息':'查看扩展信息'}}
          </span>
          <img :src="showExtendInfo?icons.upGreen:icons.downGreen" alt="icons">
        </div>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import {
  apis
} from '@common/config'
import common from '@common/common'
import headline from '@components/headline'
import dc from '@common/dc'
import empty from '@components/empty'
import Vue from 'vue'

export default {
  components: {
    headline,
    empty
  },
  watch: {
    '$route'(to, from) {
      this.getPageVersion()
    }
  },
  data() {
    return {
      headLines: {
        title: '报道详情',
        showLink: false,
        filter: false
      },
      icons: {
        up: require('@assets/img/common/upward.svg'),
        down: require('@assets/img/common/xiala.svg'),
        upGreen: require('@assets/img/common/upward_green.svg'),
        downGreen: require('@assets/img/common/downward_green.svg')
      },
      defaultImg: require('@assets/img/common/default.png'),
      defaultMedia: require('@assets/img/common/defaultMedia.png'),
      defaultAudio: require('@assets/img/common/defaultAudio.png'),
      showMedia: true,
      detail: {},
      navOn: 0,
      isDialog: false,
      fileType: false,
      reportLog: false,
      report_id: null,
      life: [],
      showVersions: false,
      history: [],
      history_id: '',
      speed: 0,
      bodyText: '', // 正文纯文字
      headText: '', // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0,  // 导语时长
      content: '',
      showExtendInfo: false,
      progressH: 0,
      isXnew: true
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    toggleExtendor() {
      this.showExtendInfo = !this.showExtendInfo
    },
    goTopic() {
      if (this.detail.st_is_delete == 1 || !this.detail.has_topic_role) return

      this.$router.push({
        path: '/topicDetail',
        query: {
          d: this.detail.st_id
        }
      })
    },
    goItv() {
      if (!this.detail.has_interview_role) return

      this.$router.push({
        path: '/interviewDetail',
        query: {
          r: this.detail.iview_id
        }
      })
    },
    watchContent(c) {
      // 检测内容变化
      const bodyText = common.getBody(c)
      const headText = common.getLead(c)

      this.bodyText = common.replacePunctuations(bodyText)
      this.headText = common.replacePunctuations(headText)
      this.calculateText()
    },
    calculateText() {
      // 计算时长
      const gap = 60/this.speed
      this.bodyDurantion = gap*this.bodyText.length
      this.headDurantion = gap*this.headText.length
    },
    goTags(i) {
      // 跳转自采线索并选中标签
      // return

      // this.$router.push({
      //   name: 'reports',
      //   params: {
      //     tag: i.title
      //   }
      // })
    },
    toVersion(info) {
      // 获取特定版本数据并渲染
      common.myFetch(apis.Rpt_history, info)
      .then(r => {
        if (r) {
          this.detail = r.detail
          this.history_id = r.detail.history_id

          this.speed = this.detail.content_speed || 0
          let content = this.detail.content
          if (this.detail.type == 0) {
            content = common.replaceN2Br(content)
          }
          this.content = content
          this.watchContent(this.detail.content)

          this.$nextTick(() => {
            common.formatXNSAudios()
          })
        }
      })
    },
    toggleVersions() {
      this.showVersions = !this.showVersions
    },
    getData() {
      const id = this.$route.query.d
      const info = {
        id: id
      }

      common.myFetch(apis.tandemDetail, info)
      .then((res) => {
        if (res) {
          this.detail = res.detail

          this.speed = this.detail.content_speed || 0
          let content = this.detail.content
          if (this.detail.type == 0) {
            content = common.replaceN2Br(content)
            // content = common.replaceBlank2NBSP(content)
          }
          this.content = content
          this.watchContent(this.detail.content)

          this.$nextTick(() => {
            common.formatXNSAudios()
          })
        }
      })
    },
    getPageVersion() {
      // 根据url参数选择渲染当前或历史版本
      const h = this.$route.query.h
      if (h) {
        const info = {
          history_id: h
        }

        this.toVersion(info)
      } else {
        this.history_id = null

        this.getData()
      }
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.getPageVersion()
  },
  created() {
    let domin = window.document.domain;
    let isXnew = true;
    if(domin.indexOf('xnews')!=-1){
      isXnew = true
    }else if(domin.indexOf('localhost')!=-1){
      isXnew = true
    }else{
      isXnew = false
    }
    this.isXnew = isXnew;
  }
}
</script>

<style src="@assets/css/mediaDetails/mediaDetails.less" lang="less" scoped></style>
